import React from 'react'
import Lottie from 'lottie-react';
import animationData from '../assets/images/animation.json'; 
import { Col, Container, Row } from 'react-bootstrap';
import Page from './Page';


export default function Reports() {
  return (
    <Page title={"Reports"} subtitle={"Dashboard > Reports"}>

      <Container>
        <Row>
          <Col md={12} className='d-flex justify-content-center align-items-center'>
            <div style={{ width: 300,}}>
              <Lottie animationData={animationData} loop={true} />
            </div>
          </Col>
        </Row>
      </Container>
    </Page>
  )
}
